import { render, staticRenderFns } from "./traffic-details.vue?vue&type=template&id=226cc121&scoped=true&"
import script from "./traffic-details.vue?vue&type=script&lang=js&"
export * from "./traffic-details.vue?vue&type=script&lang=js&"
import style0 from "./traffic-details.vue?vue&type=style&index=0&id=226cc121&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "226cc121",
  null
  
)

export default component.exports